export default __webpack_public_path__ + "static/media/Delete.e35bec34.svg";